export const AdminAuthEndpoinst = {
    login: {
        method: "post",
        url: '/users/login',
        private: false,
    },
    register: {
        method: "post",
        url: '/users/register',
        private: false,
    },
    getAllUsers: {
        method: "get",
        url: '/users',
        private: false,
    },
    getRole: {
        method: "get",
        url: '/users/role',
        private: false,
    },

}